module.exports = __webpack_public_path__ + "img/emporia_bern_compressed_ocular.d6923791.jpg";